<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">

    <div class="alert alert-danger text-center mb-4" *ngIf="propertyData && !propertyData.active">
      {{ 'properties.detail.suspended_property_alert' | translate }}
    </div>

    <!-- SHARED USER -->
    <mat-card class="custom-card mt-4">
      <mat-card-title>{{ 'properties.detail.sharedUser.title' | translate }}
      </mat-card-title>
      <mat-card-subtitle>{{ 'properties.detail.sharedUser.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="sharedUserCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="shared-user-info-wrapper">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4">
                <p class="mb-0">
                  <label>Username:</label> {{ sharedUser.get("email") }}
                </p>
                <p class="mb-0">
                  <label>Password:</label> {{ model.taxCode }}
                </p>
              </div>
              <div class="col-12 col-sm-6 col-md-8">
                <button class="navigation-button" mat-flat-button color="accent" class="float-left"
                  (click)="onSendByEmail()">
                  <mat-icon fontSet="fal" fontIcon="fa-paper-plane"></mat-icon>
                  {{ 'properties.documentsPage.sendByEmail' | translate }}
                </button>
              </div>
            </div>
          </div>
          <form class="form-shared-user" [formGroup]="formSharedUser"
            (ngSubmit)="onFormSharedUserSubmit(modelSharedUser)">
            <formly-form [form]="formSharedUser" [fields]="sharedUserFields" [model]="modelSharedUser"
              [options]="optionsSharedUser"></formly-form>
            <mat-spinner-button role="submit" [options]="formSharedUserBtnOptions" class="btn-elevate">
            </mat-spinner-button>
          </form>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->